module.exports = __webpack_public_path__ + "static/img/company_build_bg.1d64f706.png";